import {
    Box,
    Button,
    CardMedia,
    Dialog,
    Grid,
    IconButton,
    InputAdornment,
    Modal,
    TextField,
    ThemeProvider,
    Typography,
    createTheme,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import background from "../../../assests/images/mayaccountbg.png";
import Colors from "../../../assests/style";
import { useForm } from "react-hook-form";
import { SecondaryButton } from "../../../components/Buttons";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import { Images } from "../../../assests";
import { useLocation, useNavigate } from "react-router-dom";
import OrderServices from "../../../services/OrderServices";
import VisibilityOffIcon from "@mui/icons-material/VisibilityOff"
import VisibilityIcon from "@mui/icons-material/Visibility"
import Swal from "sweetalert2";
import ChatBubbleOutlineIcon from '@mui/icons-material/ChatBubbleOutline';
import PersonIcon from '@mui/icons-material/Person';
import EmailIcon from '@mui/icons-material/Email';
import ChatIcon from '@mui/icons-material/Chat';
import CloseIcon from '@mui/icons-material/Close';
import AuthServices from "../../../services/AuthServices";
import OTPInput from "react-otp-input";
import { Token } from "@mui/icons-material";

const VendorRegistration = () => {
    const navigate = useNavigate()
    const [otp, setOtp] = useState("");
    const [userObj, setUserObj] = useState(null)
    const handleVerify = () => {
        console.log("Entered OTP:", otp);
        // call your API here
    };

    const [partnerModal, setPartnerModal] = useState(false)
    const [showPasswordLogin, setShowPasswordLogin] = useState(false)
    const [showPassword, setShowPassword] = useState(false)
    const [showPassword2, setShowPassword2] = useState(false)
    const [otpScreen, setOtpScreen] = useState(false)

    const [timer, setTimer] = useState(60)

    useEffect(() => {
        let interval
        if (timer > 0) {
            interval = setInterval(() => {
                setTimer((prev) => prev - 1)
            }, 1000)
        } else {
            clearInterval(interval)
        }
        return () => clearInterval(interval)
    }, [timer])
    const {
        register,
        handleSubmit,
        formState: { errors },
        getValues,
        reset
    } = useForm();
    const [successMessage, setSuccessMessage] = useState(null);
    console.log(errors);

    const theme = createTheme({
        typography: {
            fontFamily: "Poppins, sans-serif", // You can change this to your preferred font
        },
        components: {
            MuiStepLabel: {
                styleOverrides: {
                    label: {
                        color: "rgba(255, 255, 255, 0.7)",
                        fontFamily: "Poppins, sans-serif",
                        "&.Mui-active": {
                            color: "#ffffff",
                        },
                        "&.Mui-completed": {
                            color: "#ffffff",
                        },
                    },
                },
            },
            MuiTextField: {
                styleOverrides: {
                    root: {
                        "& .MuiInputBase-root": {
                            color: "white", // Text color,
                            fontFamily: "Poppins, sans-serif",
                        },
                        "& .MuiInputLabel-root": {
                            color: "white", // Label color
                        },
                        "& .MuiInput-underline:before": {
                            borderBottomColor: "white", // Underline color when unfocused
                        },
                        "& .MuiInput-underline:after": {
                            borderBottomColor: "white", // Underline color when focused
                        },
                        "& .MuiOutlinedInput-root": {
                            "& fieldset": {
                                borderColor: "white", // Border color when unfocused
                            },
                            "&:hover fieldset": {
                                borderColor: "white", // Border color on hover
                            },
                            "&.Mui-focused fieldset": {
                                borderColor: "white", // Border color when focused
                            },
                        },
                    },
                },
            },
            MuiInputBase: {
                styleOverrides: {
                    input: {
                        color: "white", // Text color for input
                    },
                },
            },
            MuiOutlinedInput: {
                styleOverrides: {
                    notchedOutline: {
                        borderColor: "white", // Border color for input
                    },
                    root: {
                        "&:hover .MuiOutlinedInput-notchedOutline": {
                            borderColor: "white",
                        },
                        "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                            borderColor: "white",
                        },
                    },
                },
            },
            MuiInputLabel: {
                styleOverrides: {
                    root: {
                        color: "white", // Text color for label
                        borderColor: "white",
                        "&.Mui-focused": {
                            color: "white",
                        },
                    },
                },
            },
            MuiMenuItem: {
                styleOverrides: {
                    root: {
                        color: "black", // Text color for menu items
                        backgroundColor: "white", // Background color for menu items
                        "&.Mui-selected": {
                            backgroundColor: "rgba(255, 255, 255, 0.2)", // Background color for selected item
                        },
                        "&:hover": {
                            backgroundColor: "rgba(255, 255, 255, 0.1)", // Background color for hover
                        },
                    },
                },
            },
            MuiSvgIcon: {
                styleOverrides: {
                    root: {
                        color: "white", // Color for dropdown arrow
                    },
                },
            },
        },
        palette: {
            primary: {
                main: "#1976d2",
            },
            background: {
                default: "#333333",
            },
        },
    });

    const onSubmit = async (formData) => {
        setPartnerModal(false)
        try {
            let obj = {
                name: formData?.name,
                email: formData?.email,
                subject: formData?.subject,
                message: formData?.message,
            };

            const { message } = await OrderServices.SubmitMail(obj);
            console.log(message);


            Swal.fire({
                title: "Email Sent",

                icon: "success",
                background: "#0f172a", // Change to your desired background color
                color: "#fff", // Change to your desired text color
            }).then((result) => {
                if (result.isConfirmed) {
                    // window.location.href = '/my-account'; // Navigate to the home page
                }
            });
            reset();


        } catch (error) {
            console.error(error);
            Swal.fire({
                icon: "error",
                title: "Error",
                text: "There was an error sending your message. Please try again later.",
                confirmButtonText: "OK",
            });
        }
    };

    const handleRegister = async (sendData) => {
        setTimer(60)
        // console.log(sendData, "data")
        // setCurrentData(sendData)

        try {
            let obj
            if (sendData) {

                obj = {
                    name: sendData.name,
                    email: sendData.email,
                    password: sendData.password,

                }
            }
            else {
                obj = {
                    ...userObj
                }
            }
            setUserObj(obj)
            console.log(obj);

            const data = await AuthServices.authVendorRegisterViaEmail(obj)
            console.log(data)
            if (data.responseCode == 200) {
                localStorage.setItem("authToken", JSON.stringify(data?.data?.token))
                localStorage.setItem("user", JSON.stringify(sendData))
                const userInfo = localStorage.getItem("user")
                setOtpScreen(true)

            }
            if (data?.responseCode == 206) {
                setOtpScreen(true)
                // setOtpError(false)
                // setOtpEnable(true)
            }
        } catch (error) {
            Swal.fire({
                title: "An error occurred!",
                text: error,
                icon: "error",
                confirmButtonText: "OK",
            })
        }
    }
    const handleRegister2 = async (token) => {
        // setTimer(60)
        // console.log(sendData, "data")
        // setCurrentData(sendData)

        try {
            const obj = {
                otp_token: token,
                ...userObj

            }


            const data = await AuthServices.authVendorRegisterViaEmail(obj)
            console.log(data)
            if (data?.responseCode == 200) {
                console.log(`${process.env.REACT_APP_DASHBOARD_URL}/continue-registration?token=${data?.data?.token}`);

                window.location.href = `${process.env.REACT_APP_DASHBOARD_URL}/continue-registration?token=${data?.data?.token}`;
                setButtonDisabled(false)
            }


        } catch (error) {
            Swal.fire({
                title: "An error occurred!",
                text: error,
                icon: "error",
                confirmButtonText: "OK",
            })
        }
    }

    // useEffect(() => {
    //  window.loca
    // }, [third])
    const [buttonDisabled, setButtonDisabled] = useState(false)
    const submitOTP = async (sendData) => {
        setButtonDisabled(true)
        setTimer(60)
        // console.log(sendData, "data")
        // setCurrentData(sendData)

        try {
            const obj = {
                ...userObj,
                otp: otp,

            }
            //   setUserObj(obj)
            console.log(obj, 'obj');

            const data = await AuthServices.authVendorRegisterViaEmail(obj)
            console.log(data, 'datadatadata')
            if (data?.responseCode == 206) {
                handleRegister2(data?.data?.otp_token)

            }
            else {
                setButtonDisabled(false)
            }

        } catch (error) {
            setButtonDisabled(false)
            Swal.fire({
                title: "An error occurred!",
                text: error,
                icon: "error",
                confirmButtonText: "OK",
            })
        }

    }
    return (
        <div>
            <Dialog
                open={partnerModal}
                onClose={() => setPartnerModal(false)}
                aria-labelledby="dialog-title"
                aria-describedby="dialog-description"
                sx={{
                    ".MuiPaper-root": {
                        background: '#0c1427',
                        borderRadius: "12px",
                    }
                }}
                maxWidth="sm" // Adjust the maxWidth as per your needs
            >

                <Box
                    sx={{
                        backgroundColor: '#0c1427',
                        boxShadow: 24,
                        p: 4,
                        borderRadius: '12px',
                        overflow: 'hidden'
                    }}
                >
                    <Box component={'div'} onClick={() => setPartnerModal(false)} onTouchStart={() => setPartnerModal(false)} sx={{ position: 'absolute', right: 10, top: 10, display: { lg: 'block', md: 'block', sm: 'block', xs: 'block', zIndex: 99999 } }} ><IconButton sx={{ color: 'white' }} ><CloseIcon sx={{ cursor: 'pointer' }} color="white" /></IconButton></Box>
                    <Typography
                        id="dialog-title"
                        variant="h6"
                        className="heading-font2"
                        sx={{ color: 'white', textAlign: 'center' }}
                        component="h2"
                    >
                        PURR... For Help
                    </Typography>
                    {/* <form onSubmit={handleSubmit(onSubmit)}>
                        <Grid container spacing={2} mt={2} mb={2}>
                            
                            <Grid item xs={12}>
                                <TextField
                                    fullWidth
                                    placeholder="Full Name"
                                    variant="outlined"
                                    size="small"
                                    {...register("name", { required: "Name is required" })}
                                    error={!!errors.name}
                                    helperText={errors.name ? errors.name.message : ""}
                                    InputProps={{
                                        startAdornment: (
                                            <InputAdornment position="start">
                                                <PersonIcon sx={{ fontSize: '15px', mt: '2px', color: '#192133' }} />
                                            </InputAdornment>
                                        ),
                                        style: {
                                            color: "#0F172A",
                                            fontSize: "16px",
                                            borderRadius: 8, // Rounded corners
                                        },
                                    }}
                                    sx={{
                                        my: 0.5,
                                        // backgroundColor: "#1E1E1E", // Dark background color
                                        "& .MuiOutlinedInput-root": {
                                            backgroundColor: "white",
                                            "& fieldset": { borderColor: "transparent" }, // Blue border
                                            "&:hover fieldset": { borderColor: "transparent" },
                                            "&.Mui-focused fieldset": {
                                                borderColor: "transparent",
                                            },
                                        },
                                        "&.MuiFormControl-fullWidth": {
                                            background: "transparent !important",
                                            borderRadius: '10px !important'
                                        },
                                        "& .MuiInputLabel-root": { color: "black" },
                                        "& .MuiInputLabel-root.Mui-focused": { color: "black" },
                                    }}
                                />
                            </Grid>
                            <Grid item xs={12}>
                                <TextField
                                    fullWidth
                                    placeholder="Email"
                                    variant="outlined"
                                    size="small"
                                    type="email"
                                    {...register("email", { required: "Email is required" })}
                                    error={!!errors.email}
                                    helperText={errors.email ? errors.email.message : ""}
                                    InputProps={{
                                        startAdornment: (
                                            <InputAdornment position="start">
                                                <EmailIcon sx={{ fontSize: '15px', mt: '2px', color: '#192133' }} />
                                            </InputAdornment>
                                        ),
                                        style: {
                                            color: "#0F172A",
                                            fontSize: "16px",
                                            borderRadius: 8, // Rounded corners
                                        },
                                    }}
                                    sx={{
                                        my: 0.5,
                                        backgroundColor: "#1E1E1E", // Dark background color
                                        "& .MuiOutlinedInput-root": {
                                            backgroundColor: "white",
                                            "& fieldset": { borderColor: "transparent" }, // Blue border
                                            "&:hover fieldset": { borderColor: "transparent" },
                                            "&.Mui-focused fieldset": {
                                                borderColor: "transparent",
                                            },
                                        },
                                        "&.MuiFormControl-fullWidth": {
                                            background: "transparent !important",
                                            borderRadius: '10px !important'
                                        },
                                        "& .MuiInputLabel-root": { color: "black" },
                                        "& .MuiInputLabel-root.Mui-focused": { color: "black" },
                                    }}
                                />
                            </Grid>
                            <Grid item xs={12}>
                                <TextField
                                    fullWidth
                                    placeholder="Subject"
                                    variant="outlined"
                                    size="small"
                                    {...register("subject", { required: "subject is required" })}
                                    error={!!errors.subject}
                                    helperText={errors.subject ? errors.subject.message : ""}
                                    InputProps={{
                                        startAdornment: (
                                            <InputAdornment position="start">

                                                <ChatIcon sx={{ fontSize: '15px', mt: '2px', color: '#192133' }} />

                                            </InputAdornment>
                                        ),
                                        style: {
                                            color: "#0F172A",
                                            fontSize: "16px",
                                            borderRadius: 8, // Rounded corners
                                        },
                                    }}

                                    sx={{
                                        my: 0.5,
                                        // backgroundColor: "#1E1E1E", // Dark background color
                                        "& .MuiOutlinedInput-root": {
                                            backgroundColor: "white",
                                            "& fieldset": { borderColor: "transparent" }, // Blue border
                                            "&:hover fieldset": { borderColor: "transparent" },
                                            "&.Mui-focused fieldset": {
                                                borderColor: "transparent",
                                            },
                                        },
                                        "&.MuiFormControl-fullWidth": {
                                            background: "transparent !important",
                                            borderRadius: '10px !important'
                                        },
                                        "& .MuiInputLabel-root": { color: "black" },
                                        "& .MuiInputLabel-root.Mui-focused": { color: "black" },
                                    }}
                                />
                            </Grid>
                            <Grid item xs={12}>
                                <TextField
                                    fullWidth
                                    placeholder="Message"
                                    variant="outlined"
                                    size="small"
                                    multiline
                                    rows={7}
                                    {...register("message", { required: "message is required" })}
                                    error={!!errors.message}
                                    helperText={errors.message ? errors.message.message : ""}

                                    sx={{
                                        my: 0.5,
                                        // backgroundColor: "#1E1E1E", // Dark background color
                                        "& .MuiOutlinedInput-root": {
                                            borderRadius: '8px !important',
                                            backgroundColor: "white",
                                            "& fieldset": { borderColor: "transparent" }, // Blue border
                                            "&:hover fieldset": { borderColor: "transparent" },
                                            "&.Mui-focused fieldset": {
                                                borderColor: "transparent",
                                            },
                                        },
                                        "&.MuiFormControl-fullWidth": {
                                            background: "transparent !important",
                                            borderRadius: '12px !important'
                                        },
                                        "& .MuiInputLabel-root": { color: "black" },
                                        "& .MuiInputLabel-root.Mui-focused": { color: "black" },
                                    }}
                                />

                            </Grid>
                            <Grid item xs={12}>
                                <SecondaryButton
                                    type="submit"
                                    bgColor="#0bc1d9"
                                    fullWidth
                                    className="checkout-btn"
                                    iconPosition="end"
                                    icon={<ArrowForwardIcon sx={{ color: '#0C1427' }} />}
                                    p="10px 20px"
                                    fontWeight="bold"
                                    color="#0C1427"
                                    title="Submit"
                                />
                            </Grid>
                        </Grid>
                    </form> */}
                </Box>

            </Dialog>

            <Box
                sx={{
                    backgroundImage: `url("${Images.contactBg}")`,
                    backgroundSize: "cover",
                    backgroundRepeat: "no-repeat",
                    backgroundPosition: "center",
                    width: "100%",
                    height: { lg: "300px", md: '300px', sm: '220px', xs: '220px' }, // Adjust height as needed
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    position: "relative",
                }}
            >
                {/* <Box
                    sx={{
                        position: "absolute",
                        top: 0,
                        width: "100%",
                        height: "100%",
                        background: Colors.backgroundColor1
                    }}
                /> */}
                <Box
                    sx={{
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        gap: 1.5,
                    }}
                >
                    <Box
                        component={"p"}
                        className="banner-text heading-font"
                        sx={{
                            fontSize: { lg: "52px", md: "52px", sm: "52px", xs: "30px" },
                            textAlign: "center",
                            fontFamily: "Noto Sans, sans-serif",
                        }}
                    >
                        {" "}
                        Vendor{" "}
                    </Box>
                    <Box
                        component={"span"}
                        className="banner-text heading-font"
                        sx={{
                            fontSize: { lg: "52px", md: "52px", sm: "52px", xs: "30px" },
                            textAlign: "center",
                            fontFamily: "Noto Sans, sans-serif",
                        }}
                    >
                        {" "}
                        Registration{" "}
                    </Box>
                    <Box
                        component={"span"}
                        className="banner-text heading-font"
                        sx={{
                            fontSize: { lg: "52px", md: "52px", sm: "52px", xs: "30px" },
                            textAlign: "center",
                            fontFamily: "Noto Sans, sans-serif",
                        }}
                    >
                        {" "}
                        Form{" "}
                    </Box>
                    {/* <p style={{ fontSize: '25px', textAlign: 'center', color: 'white', fontFamily: "Noto Sans, sans-serif", }}>Homepage || <span style={{ color: Colors.secondary }}>Contact Us</span></p> */}
                </Box>
            </Box>
            <Box component={"section"} sx={{
                py: 10, display: 'flex', justifyContent: 'center',
                backgroundImage: `url(${Images.frameBg})`,
                backgroundSize: "cover", // Adjust the image size
                backgroundPosition: "center", // Position the image
                backgroundRepeat: "no-repeat", // Avoid repeating the image,
            }}>
                {!otpScreen ? <Grid container xs={10} md={6} lg={4} p={5} sx={{ backgroundColor: '#0F172A', borderRadius: '15px' }}>


                    <form onSubmit={handleSubmit(handleRegister)}>
                        {/* Name Field */}
                        <Typography
                            className="heading-font"
                            variant="h5"
                            mb={2}
                            sx={{
                                fontWeight: "bold",
                                textAlign: "center",
                                fontFamily: "Plus Jakarta Sans",
                            }}
                        >
                            Vendor Registration Form
                        </Typography>
                        <TextField
                            fullWidth
                            placeholder="Full Name"
                            variant="outlined"
                            size="small"
                            {...register("name", { required: "Name is required" })}
                            error={!!errors.name}
                            helperText={errors.name ? errors.name.message : ""}
                            InputProps={{
                                startAdornment: (
                                    <InputAdornment position="start">
                                        <Box component={"img"} src={Images.nameIcon} width={"17px"}></Box>
                                    </InputAdornment>
                                ),
                                style: {
                                    color: "#0F172A",
                                    fontSize: "16px",
                                    borderRadius: 8, // Rounded corners
                                },
                            }}
                            sx={{
                                my: 1,
                                // backgroundColor: "#1E1E1E", // Dark background color
                                "& .MuiOutlinedInput-root": {
                                    backgroundColor: "white",
                                    "& fieldset": { borderColor: "transparent" }, // Blue border
                                    "&:hover fieldset": { borderColor: "transparent" },
                                    "&.Mui-focused fieldset": {
                                        borderColor: "transparent",
                                    },
                                },
                                "&.MuiFormControl-fullWidth": {
                                    background: "transparent !important",
                                    borderRadius: "10px !important",
                                },
                                "& .MuiInputLabel-root": { color: "black" },
                                "& .MuiInputLabel-root.Mui-focused": { color: "black" },
                            }}
                        />

                        {/* Email Field */}
                        <TextField
                            fullWidth
                            placeholder="Email"
                            variant="outlined"
                            size="small"
                            type="email"
                            {...register("email", { required: "Email is required" })}
                            error={!!errors.email}
                            helperText={errors.email ? errors.email.message : ""}
                            InputProps={{
                                startAdornment: (
                                    <InputAdornment position="start">
                                        <Box component={"img"} src={Images.emailIcon} width={"17px"}></Box>
                                    </InputAdornment>
                                ),
                                style: {
                                    color: "#0F172A",
                                    fontSize: "16px",
                                    borderRadius: 8, // Rounded corners
                                },
                            }}
                            sx={{
                                my: 1,
                                backgroundColor: "#1E1E1E", // Dark background color
                                "& .MuiOutlinedInput-root": {
                                    backgroundColor: "white",
                                    "& fieldset": { borderColor: "transparent" }, // Blue border
                                    "&:hover fieldset": { borderColor: "transparent" },
                                    "&.Mui-focused fieldset": {
                                        borderColor: "transparent",
                                    },
                                },
                                "&.MuiFormControl-fullWidth": {
                                    background: "transparent !important",
                                    borderRadius: "10px !important",
                                },
                                "& .MuiInputLabel-root": { color: "black" },
                                "& .MuiInputLabel-root.Mui-focused": { color: "black" },
                            }}
                        />

                        {/* Password Field */}
                        <TextField
                            fullWidth
                            placeholder="Password"
                            variant="outlined"
                            size="small"
                            type={showPassword ? "text" : "password"}
                            {...register("password", {
                                required: "Password is required",
                            })}
                            error={!!errors.password}
                            helperText={errors.password ? errors.password.message : ""}
                            InputProps={{
                                startAdornment: (
                                    <InputAdornment position="start">
                                        <Box component={"img"} src={Images.passwordIcon} width={"17px"}></Box>
                                    </InputAdornment>
                                ),
                                endAdornment: (
                                    <InputAdornment position="end">
                                        <IconButton onClick={() => setShowPassword(!showPassword)} edge="end">
                                            {showPasswordLogin ? (
                                                <VisibilityIcon sx={{ color: "#0F172A", fontSize: "20px" }} />
                                            ) : (
                                                <VisibilityOffIcon sx={{ color: "#0F172A", fontSize: "20px" }} />
                                            )}
                                        </IconButton>
                                    </InputAdornment>
                                ),
                                style: {
                                    color: "#0F172A",
                                    fontSize: "16px",
                                    borderRadius: 8, // Rounded corners
                                },
                            }}
                            sx={{
                                my: 1,
                                backgroundColor: "#1E1E1E", // Dark background color
                                "& .MuiOutlinedInput-root": {
                                    backgroundColor: "white",
                                    "& fieldset": { borderColor: "transparent" }, // Blue border
                                    "&:hover fieldset": { borderColor: "transparent" },
                                    "&.Mui-focused fieldset": {
                                        borderColor: "transparent",
                                    },
                                },
                                "&.MuiFormControl-fullWidth": {
                                    background: "transparent !important",
                                    borderRadius: "10px !important",
                                },
                                "& .MuiInputLabel-root": { color: "black" },
                                "& .MuiInputLabel-root.Mui-focused": { color: "black" },
                            }}
                        />

                        {/* Confirm Password Field */}
                        <TextField
                            fullWidth
                            placeholder="Confirm Password"
                            size="small"
                            variant="outlined"
                            type={showPassword2 ? "text" : "password"}
                            {...register("confirmPassword", {
                                required: "Confirm Password is required",
                                validate: (value) => value === getValues("password") || "Passwords do not match",
                            })}
                            error={!!errors.confirmPassword}
                            helperText={errors.confirmPassword ? errors.confirmPassword.message : ""}
                            InputProps={{
                                startAdornment: (
                                    <InputAdornment position="start">
                                        <Box component={"img"} src={Images.passwordIcon} width={"17px"}></Box>
                                    </InputAdornment>
                                ),
                                endAdornment: (
                                    <InputAdornment position="end">
                                        <IconButton onClick={() => setShowPassword2(!showPassword2)} edge="end">
                                            {showPasswordLogin ? (
                                                <VisibilityIcon sx={{ color: "#0F172A", fontSize: "20px" }} />
                                            ) : (
                                                <VisibilityOffIcon sx={{ color: "#0F172A", fontSize: "20px" }} />
                                            )}
                                        </IconButton>
                                    </InputAdornment>
                                ),
                                style: {
                                    color: "#0F172A",
                                    fontSize: "16px",
                                    borderRadius: 8, // Rounded corners
                                },
                            }}
                            sx={{
                                my: 1,
                                backgroundColor: "#1E1E1E", // Dark background color
                                "& .MuiOutlinedInput-root": {
                                    backgroundColor: "white",
                                    "& fieldset": { borderColor: "transparent" }, // Blue border
                                    "&:hover fieldset": { borderColor: "transparent" },
                                    "&.Mui-focused fieldset": {
                                        borderColor: "transparent",
                                    },
                                },
                                "&.MuiFormControl-fullWidth": {
                                    background: "transparent !important",
                                    borderRadius: "10px !important",
                                },
                                "& .MuiInputLabel-root": { color: "black" },
                                "& .MuiInputLabel-root.Mui-focused": { color: "black" },
                            }}
                        />

                        {/* Submit Button */}
                        <Button
                            fullWidth
                            type="submit"
                            variant="contained"
                            sx={{
                                backgroundColor: "#0EA5EA",
                                color: "#22272d",
                                padding: "6px",
                                fontSize: "16px",
                                fontWeight: "bold",
                                borderRadius: 2,
                                textTransform: "capitalize",
                                mt: 1,

                                "&:hover": { backgroundColor: "#0EA5EA" },
                            }}

                        >
                            Register
                        </Button>
                        <Typography variant="body2" sx={{ color: "#0EA5EA", textAlign: "center", mt: 2 }}>
                            Already have an account?{" "}
                            <span
                                style={{
                                    fontWeight: "bold",
                                    cursor: "pointer",
                                    textDecoration: "underline",
                                    color: "#0EA5EA",
                                }}
                                onClick={() => {
                                    window.location.href = `${process.env.REACT_APP_DASHBOARD_URL}/vendor-login`;
                                }}
                            >
                                Login
                            </span>
                        </Typography>
                    </form>
                </Grid> : <Grid
                    container
                    xs={10}
                    md={6}
                    lg={4}
                    p={5}
                    justifyContent="center"
                    sx={{ backgroundColor: "#0F172A", borderRadius: "15px" }}
                >
                    <Box sx={{ width: "100%" }}>
                        <Typography
                            className="heading-font"
                            variant="h5"
                            mb={2}
                            sx={{
                                fontWeight: "bold",
                                textAlign: "center",
                                fontFamily: "Plus Jakarta Sans",
                                color: "#fff",
                            }}
                        >
                            Verification
                        </Typography>

                        <Typography
                            sx={{
                                textAlign: "center",
                                color: "#ccc",
                                fontSize: "14px",
                                mb: 1,
                            }}
                        >
                            We have sent you <b>One Time Password</b> to your email
                        </Typography>

                        <Typography
                            sx={{
                                textAlign: "center",
                                color: "#0EA5EA",
                                fontSize: "14px",
                                mb: 3,
                            }}
                        >
                            Please enter OTP code
                        </Typography>

                        {/* OTP Input */}
                        <Box display="flex" justifyContent="center" mb={3}>
                            <div className="otp-container2">
                                <OTPInput
                                    value={otp}
                                    onChange={setOtp}
                                    numInputs={4}
                                    renderSeparator={<span className="separator">-</span>}
                                    renderInput={(props) => <input className="otp-input" {...props} />}
                                />
                            </div>
                        </Box>

                        {/* Buttons */}
                        <Box display="flex" justifyContent="space-between" mt={5} gap={2}>
                            <Button
                                fullWidth
                                variant="outlined"
                                disabled={timer > 0}
                                onClick={() => handleRegister()}
                                sx={{
                                    color: "#0EA5EA",
                                    borderColor: "#0EA5EA",
                                    fontWeight: "bold",
                                    borderRadius: 2,
                                    textTransform: "capitalize",
                                    "&.Mui-disabled": {
                                        color: "gray",         // text color when disabled
                                        borderColor: "gray",   // border color when disabled
                                    },
                                }}
                            >
                                Resend OTP {timer != 0 ? `in ${timer}s ` : ''}
                            </Button>

                            <Button
                                fullWidth
                                type="submit"
                                variant="contained"
                                disabled={buttonDisabled}
                                sx={{
                                    backgroundColor: "#0EA5EA",
                                    color: "#22272d",
                                    fontSize: "16px",
                                    fontWeight: "bold",
                                    borderRadius: 2,
                                    textTransform: "capitalize",
                                    "&:hover": { backgroundColor: "#0EA5EA" },
                                }}
                                onClick={() => submitOTP()}
                            >
                                Verify OTP
                            </Button>
                        </Box>
                    </Box>
                </Grid>}
            </Box>
            {/* <ThemeProvider theme={theme}>
                <Box sx={{ width: { xs: '90%', sm: '70%', md: '70%' }, margin: '0 auto' }}>
                    <form onSubmit={handleSubmit(onSubmit)}>

                        <Grid container spacing={2} mt={5} mb={5}>
                            <Grid item xs={12} md={6}>
                                <TextField
                                    label="Your Name"
                                    {...register('name', { required: true })}
                                    error={!!errors.name}
                                    sx={{ input: { color: 'white' }, label: { color: 'white' }, '& .MuiOutlinedInput-notchedOutline': { borderColor: 'white' } }}
                                    helperText={errors.name ? 'Name is required' : ''}
                                    fullWidth
                                />
                            </Grid>
                            <Grid item xs={12} md={6}>
                                <TextField
                                    label="Email Address"
                                    {...register('email', {
                                        required: true,
                                        pattern: /^[^\s@]+@[^\s@]+\.[^\s@]+$/
                                    })}
                                    error={!!errors.email}
                                    sx={{
                                        input: { color: 'white' },
                                        label: { color: 'white' },
                                        '& .MuiOutlinedInput-notchedOutline': {
                                            borderColor: 'white',
                                            '&:hover': {
                                                borderColor: 'white'
                                            }
                                        }
                                    }}
                                    helperText={errors.email ? 'Invalid email address' : ''}
                                    fullWidth
                                />
                            </Grid>


                            <Grid item xs={12} md={6}>
                                <TextField
                                    label="Phone Number"
                                    {...register('phone', {
                                        required: true,

                                    })}
                                    type='number'
                                    error={!!errors.phone}
                                    sx={{ input: { color: 'white' }, label: { color: 'white' }, '& .MuiOutlinedInput-notchedOutline': { borderColor: 'white' } }}
                                    helperText={errors.phone ? 'Invalid phone number' : ''}
                                    fullWidth
                                />
                            </Grid>
                            <Grid item xs={12} md={6}>


                                <TextField
                                    label="Subject"
                                    {...register('subject', { required: true })}
                                    error={!!errors.subject}
                                    sx={{ input: { color: 'white' }, label: { color: 'white' }, '& .MuiOutlinedInput-notchedOutline': { borderColor: 'white' } }}
                                    helperText={errors.subject ? 'Subject is required' : ''}
                                    fullWidth
                                />
                            </Grid>
                            <Grid item xs={12} >
                                <TextField
                                    label="Message"
                                    {...register('message', { required: true })}
                                    error={!!errors.message}
                                    sx={{ input: { color: 'white' }, label: { color: 'white' }, '& .MuiOutlinedInput-notchedOutline': { borderColor: 'white' } }}
                                    helperText={errors.message ? 'Message is required' : ''}
                                    multiline
                                    rows={6}
                                    fullWidth
                                />
                            </Grid>
                            {successMessage && (
                            <Grid item xs={12}>
                                <Typography variant="body1" color="green" gutterBottom>
                                    {successMessage}
                                </Typography>
                            </Grid>
                        )}
                            <Grid item xs={12}>
                                <SecondaryButton
                                    type={'submit'}
                                    bgColor={'#0bc1d9'} fullWidth={true} className={'checkout-btn'} iconPosition={'end'} icon={<ArrowForwardIcon sx={{ color: '#0C1427' }} />} p={"15px 40px"} fontWeight={'bold'} color={'#0C1427'} title={'Send Message'} />
                            </Grid>
                        </Grid>
                    </form>
                </Box>
            </ThemeProvider> */}
        </div>
    );
};

export default VendorRegistration;
